import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, TextField } from "@mui/material";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import ModalActions from "../../common/ModalActions";

function Edit({ open, onClose, comic, onComicUpdated }) {
  const [title, setTitle] = useState("");
  const [series, setSeries] = useState("");

  useEffect(() => {
    if (comic) {
      setTitle(comic.title);
      setSeries(comic.series);
    }
  }, [comic]);

  const handleUpdateComic = async () => {
    try {
      const comicRef = doc(db, "Comics", comic.id);
      await updateDoc(comicRef, {
        title,
        series,
      });
      onClose();
      onComicUpdated();
    } catch (error) {
      console.error("Error updating comic: ", error);
    }
  };

  const handleDeleteComic = async () => {
    try {
      const comicRef = doc(db, "Comics", comic.id);
      await deleteDoc(comicRef);
      onClose();
      onComicUpdated();
    } catch (error) {
      console.error("Error deleting comic: ", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <ModalDialogTitle onClose={onClose}>Edit Comic</ModalDialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Series"
          fullWidth
          value={series}
          onChange={(e) => setSeries(e.target.value)}
        />
      </DialogContent>
      <ModalActions
        onSave={handleUpdateComic}
        onDelete={handleDeleteComic}
        saveLabel="Update"
      />
    </Dialog>
  );
}

export default Edit;
